Librarian.Popup = new Class({
    Extends: Librarian.Window,
    Binds: ["onCancel", "onSelectBU", "submitSurvey", "addResponse"],

    options: {
        id: "popup",
        type: "modal",
        title: "",
        width: 625,
        height: 350,
        contentURL: null,
        // Make the window square
        cornerRadius: 0,
        // Increase height of the header and center controls in new space
        headerHeight: 25,
        controlsOffset: {
            right: 5,
            top: 5
        },
        headerStartColor: [0, 0, 0],
        headerStopColor: [0, 0, 0],
        bodyBgColor: [255, 255, 255, 0],
        toolbarHeight: 32,
        footerHide: true,
        maximizeBgAlpha: 0,
        maximizeAlpha: 0,
        minimizeBgAlpha: 0,
        minimizeAlpha: 0,
        closeBgAlpha: 0,
        closeAlpha: 0,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        showOnce: false,
        popup: null,
        businessUnitsDropdown: null,
        onClose: null,
        image: null,
        htmlFile: null,
        isSurvey: false,
        useIframe: true,
        showOnceLinkClicked: false
    },


    initialize: function(options) {
        this.setOptions(options);

        if (!this.options.contentURL) {
            this.options.contentURL = Librarian.path.getLayoutsPath() + "pages/popup.html";
        }

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();
        this.setupElements();

        this.setImage();
        this.setHtml();
        this.saveSetting();
    },

    saveSetting: function() {
        if (this.hasCompletedForm || (this.options.showOnce && !this.options.isSurvey)) {
            Librarian.PopupSetup.saveSetting(this.options.popupOptions);
        } else {
            Librarian.PopupSetup.deleteSetting(this.options.popupOptions);
        }
    },

    setImage: function() {
        var imgEl = this.getElement("popup_bg");
        if (imgEl) {
            if (this.options.image && this.options.image.length > 0) {
                var imageUrl = Librarian.path.getDownloadUrl("dnld") + "&track=false&fname=" + this.options.image;
                imgEl.set("src", imageUrl);
            }
            else
                imgEl.destroy();
        }
    },

    setHtml: function() {
        if (this.options.htmlFile && this.options.htmlFile.length > 0) {
            var contEl = this.getElement("popup_htmlContent");
            var self = this;

            if (this.options.useIframe) {
                var htmlIFrame = new IFrame({
                    src: Librarian.path.getDownloadUrl("open") + "&fname=" + this.options.htmlFile,

                    events: {
                        load: function() {
                            var document = this.contentDocument || this.contentWindow.document;
                            var form = document.getElementsByTagName("form");

                            if (form && form.length > 0) {
                                form[0].addEventListener("submit", function() {
                                    var formData = Librarian.Utils.getFormData(serialize(this));

                                    if (self.options.isSurvey) {
                                        self.submitSurvey(formData);
                                    }
                                });
                            }

                            var anchors = document.getElementsByTagName("a");
                            for (var i = 0, len = anchors.length; i < len; i++) {

                                if (anchors[i].classList.contains('static')) {
                                    continue;
                                }

                                anchors[i].addEventListener("click", function() {
                                    setTimeout(function () {
                                        if (self.options.showOnceLinkClicked) {
                                            self.hasCompletedForm = true;
                                        }
                                        self.close();
                                    }, 100);
                                });
                            }
                        }
                    }
                });
                htmlIFrame.addClass("popup_htmlContent_Iframe");
                contEl.grab(htmlIFrame);
            } else {
                Librarian.Utils.getSlideText({ filename: this.options.htmlFile, slidenumber: 1 }, function(data) {
                    contEl.set("html", data.Text);
                    this.closeWindowOnLinkClick();
                }.bind(this));
            }

        }
    },

    submitSurvey: function(formData) {
        Object.each(formData, this.addResponse);
        this.hasCompletedForm = true;
        this.close();
    },

    addResponse: function(response, topic) {
        var self = this;
        var subject = this.options.popupOptions.id + "_" + this.options.popupOptions.version + "_" + topic;

        this.getTopic(subject, function(topics) {
            if (topics && topics.length > 0) {
                var topicObj = topics[0];
                self.addTopicMessage(topicObj.topicId, response);

            } else {
                self.createTopic(subject, topic, function(topic) {
                    self.addTopicMessage(topic.topicId, response);
                });
            }
        });
    },

    getTopic: function(topicSubject, callBack) {
        var url = Librarian.path.getCollaborationUrl("getTopics");
        var topicOptions = {
            SubjectFilter: topicSubject
        }
        var data = JSON.stringify(topicOptions);
        if (typeof Base64 != "undefined")
            data = Base64.encode(data);

        new Librarian.Request.JSON({
            method: "post",
            url: url + "&in=cjson&out=cjson",
            data: data,
            onSuccess: callBack || Librarian.Utils.blankFunction,
            onFailure: Librarian.Utils.onFailure
        }).send();

    },

    createTopic: function(subject, message, callBack) {
        var url = Librarian.path.getCollaborationUrl("addtopic");
        var topic = {
            subject: subject,
            message: message,
            flags: Librarian.topicFlags.internal
        };

        var data = JSON.stringify(topic);
        if (typeof Base64 != "undefined")
            data = Base64.encode(data);

        new Librarian.Request.JSON({
            method: "post",
            url: url + "&in=cjson&out=cjson",
            data: data,
            onSuccess: callBack || Librarian.Utils.blankFunction,
            onFailure: Librarian.Utils.onFailure
        }).send();

    },

    addTopicMessage: function(topicId, message, callback) {
        var url = Librarian.path.getCollaborationUrl("addtopicmsg");
        var topicMessage = {
            topicId: topicId,
            message: message
        }

        var data = JSON.stringify(topicMessage);
        if (typeof Base64 != "undefined")
            data = Base64.encode(data);

        new Librarian.Request.JSON({
            method: "post",
            url: url + "&in=cjson&out=cjson",
            data: data,
            onSuccess: callback || Librarian.Utils.blankFunction,
            onFailure: Librarian.Utils.onFailure
        }).send();

    },

    closeWindowOnLinkClick: function() {
        var elements = this.windowEl.getElements("a");
        var self = this;

        elements.addOnClick(function () {
            setTimeout(function () {
                if (self.options.showOnceLinkClicked) {
                    self.hasCompletedForm = true;
                }
                self.close();
            }, 100);
        }.bind(this));
    },

    onClose: function() {
        this.saveSetting();
    },

    onCancel: function () {
        this.close();
    }
});

Librarian.PopupSetup =
{
    getSettings: function() {
        // If the popups are already defined in settings, use those
        if (Librarian.loginPopup.popups) {
            Librarian.PopupSetup.initPopups({
                popups: Librarian.loginPopup.popups
            });
            return;
        }

        // Otherwise, load popups from json file
        var jsonFile = Librarian.loginPopup.jsonFile;
        if (!jsonFile)
            return;

        Librarian.Utils.getSlideText({ filename: jsonFile }, function (slideText) {
            if (slideText && slideText.Text) {
                var jsonText = slideText.Text.replace(/\/\/.+/g, "");
                Librarian.PopupSetup.initPopups(JSON.parse(jsonText));
            }
        });
    },

    initPopups: function(popups) {
        var windowChain = new Chain();

        Array.each(popups.popups, function(popup) {
            if (Librarian.PopupSetup.isPopupEnabled(popup) && !popup.linkedTo) {
                var showPopup = function(popup, parent) {
                    if (parent && !Librarian.PopupSetup.hasCompletedForm(parent)) {
                        windowChain.callChain();
                    } else {
                        var modalClose = popup.modalOverlayClose;
                        if(modalClose != false) modalClose = true;
                        var windowPopup = new Librarian.Popup({
                            height: popup.height,
                            width: popup.width,
                            image: popup.image,
                            businessUnitsDropdown: popup.businessUnitsDropdown,
                            showOnce: popup.showOnce,
                            popupOptions: popup,
                            htmlFile: popup.htmlFile,
                            isSurvey: popup.isSurvey,
                            useIframe: popup.useIframe,
                            modalOverlayClose: modalClose,
                            showOnceLinkClicked: popup.showOnceLinkClicked
                        });
                        windowPopup.show();

                        windowPopup.addEvent("onCloseComplete", function() {
                            setTimeout(function() {
                                windowChain.callChain();
                            }, 250);

                        });
                    }
                }
                windowChain.chain(showPopup.pass(popup));

                var popupChildren = popups.popups.filter(function(item) {
                    return item.linkedTo === popup.id;
                });

                popupChildren.each(function(item) {
                    windowChain.chain(showPopup.pass([item, popup]));
                });
            }
        });

        windowChain.callChain();
    },

    isPopupEnabled: function(popup) {
        var today = new Date();

        // Do not show if scheduled in the future
        if (popup.startDate) {
            var startDate = Librarian.Utils.extractDateFromString(popup.startDate);
            if (startDate && startDate > today) {
                return false;
            }
        }

        // Do not show if campaign ended already
        if (popup.endDate) {
            var endDate = Librarian.Utils.extractDateFromString(popup.endDate);
            if (endDate && endDate < today) {
                return false;
            }
        }

        // Do not show if they should only see it once
        if (popup.showOnce || popup.showOnceLinkClicked) {
            if (Librarian.PopupSetup.hasCompletedForm(popup)) {
                return false;
            }
        }

        // Do not show if they are part of the exclusion list
        if (popup.exclusionList && popup.exclusionList.length > 0) {
            if (Librarian.Utils.isUserMemberOfGroupLike(popup.exclusionList)) {
                return false;
            }      
        }

        // Do not show if they are not part of the inclusion list
        if (popup.inclusionList && popup.inclusionList.length > 0) {
            if (!Librarian.Utils.isUserMemberOfGroupLike(popup.inclusionList)) {
                return false;
            }
        } else {
            return true;
        }

        return true;
    },

    getSettingName: function(popup) {
        if (popup)
            return "webclient.popup." + Librarian.path.getUrlLibraryName() + "." + popup.id + "." + popup.version;
    },

    getCookieName: function(popup) {
        if (popup)
            return "AccentPopup-" + popup.id + "-ver-" + popup.version + "-" + Librarian.path.getUrlLibraryName() + "-" + Librarian.userInfo.UserId;
    },

    hasCompletedForm: function(popup) {
        var settingName = Librarian.PopupSetup.getSettingName(popup);
        var cookieName = Librarian.PopupSetup.getCookieName(popup); // TODO: For backwards compatibility. Remove later

        return Librarian.Utils.getUserSetting(settingName, cookieName);
    },

    saveSetting: function(popup) {
        var settingName = Librarian.PopupSetup.getSettingName(popup);

        Librarian.Utils.setUserSetting(settingName, true);
    },

    deleteSetting: function(popup) {
        var settingName = Librarian.PopupSetup.getSettingName(popup);

        Librarian.Utils.deleteUserSetting(settingName);
    }
}